import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconVoice2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVoice2"><Path d="M17.7385 19.3829C13 19.5 6.73293 11.7 2.5 11.7" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/><Path d="M4.40625 17.55C10.5969 17.55 14.8324 9.75 21.0014 9.75" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconVoice2;
